import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

const ScrollToTop = () => {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.scrollTo(0, 0);
    const main = document.getElementById('main-content');
    if (main) {
      if (!main.hasAttribute('tabindex')) {
        main.setAttribute('tabindex', '-1');
      }
      window.requestAnimationFrame(() => {
        (main as HTMLElement).focus({ preventScroll: true });
      });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
